/**
 * Widget-local stable text maps/constants for RasterStatistics.
 *
 * Kept separate so the container stays small and large literal objects are not
 * recreated on every render.
 */

export const defaultNls = Object.freeze({
  avgTxt: "Mittelwert",
  medTxt: "Mittel",
  minTxt: "Minimium",
  maxTxt: "Maximum",
  count: "Anzahl",
  area: "Fläche",
  timespan: "Zeitraum",
  noLayer: "Wählen Sie einen Parameter mit Zeitabschnitt aus.",
  loading: "Berechne ...",
  noData: "Keine Daten",
  error: "Es ist ein Fehler aufgetreten",
  title: "Statistik",
  drawPolygon: "Polygon zeichnen",
  drawExtent: "Extent zeichnen",
  areaInfo:
    "Zeichnen sie nun mit Klicks die Geometrie auf der Map ein. Mit einem Doppelklick wird das Zeichnen abgeschlossen.",
  complete: "Abschließen",
  abort: "Abbrechen",
  clear: "Clear",
  selectionStatistic: "Auswahl",
  timeOverviewStatistic: "Übersicht",
  areaRestriction:
    // eslint-disable-next-line no-template-curly-in-string
    "Bitte wählen sie einen kleineren Bereich aus. (Maximal: ${restriction}km², Ausgewählt: ${area}km²)",
  createFactSheet: "Faktenblatt erstellen",
  createFactSheetTooltipParameter:
    "Bitte Kategorie, Parameter und Zeitabschnitt auswählen.",
  createFactSheetTooltipRegion: "Bitte eine Region auswählen.",
  download: "Download des Faktenblatts",
  starText: "Datengrundlage: Rasterdaten des DWD",
  doublestarText:
    "Die angegebene Zahl für den angegebenen Zeitraum aus 4 Klimaprojektionen (30 Jahreswerte * 4 Projektionen). Die zugrundeliegenden modellierten Daten unterliegen einer höheren Unischerheit als Messwerte und sind daher nur unter Beachtung der Modellannahmen zu verwenden. Sie bilden nur eine von vielen möglichen Zukünften ab. Weitere Informationen befinden sich unter Projektinformationen. (Datengrundlage: Niedersächsische Klimaensemble AR5-NI v2.1)",
  playing:
    "Statistiken stehen nicht zur Verfügung, während die Zeiträume animiert dargestellt werden. Um die Statistik abzurufen pausieren sie die Animation.",
  region: "Region",
  szenario: "Szenario",
  timespanTable: "Tabelle",
  timespanChart: "Grafik",
  datengrundlageText:
    'Die Beobachtungsdaten stammen vom Deutschen Wetterdienst (DWD) und die Klimaszenariendaten (RCP2.6 und RCP8.5) vom Niedersächsischen Kompetenzzentrum Klimawandel (NIKO). Die dargestellten Werte sind immer Mittelwerte aus einem 30-jährigen Zeitraum, da zur Beschreibung eines Klimasignals Zeiträume von mindestens 30 Jahren erforderlich sind. Auswertungen für einzelne Jahre finden sich auf der NIKO-Webseite (<a href="https://niko-klima.de/klimawissen" target="_blank" rel="noopener noreferrer">niko-klima.de/klimawissen</a>).',
});

export const defaultTimeOverviewNls = Object.freeze({
  statistischeKennzahlen: "",
  attribute: "Zeitraum",
  value: "Mittelwert",
  beobachtungsdaten: "Beobachtungsdaten",
  projektionsdaten: "Projektionsdaten",
  rcp26: "RCP2.6",
  rcp85: "RCP8.5",
});
